import React from "react";

import { QRFRameProps } from "../types";

import { getPreviewFrameFontSize } from "@/utils/qrEditorHelper";
import "../styles.scss";

export const starsFrame = (
  props: Omit<QRFRameProps, "frameType">
): React.SVGProps<SVGSVGElement> => {
  const { text, textColor, children, frameColor, frameBackgroundColor, urlQr } = props;

  const fontSize = getPreviewFrameFontSize(text?.length);

  return (
    <svg
      width="96"
      height="128"
      viewBox="0 0 96 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        stroke="#BFBFBF"
      />
      <g opacity="0.947">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M62.6696 25.0321C63.6249 25.017 64.4798 25.2975 65.2341 25.8736C66.0774 26.8041 66.2244 27.8327 65.6749 28.9591C62.7412 33.2019 59.2284 36.9016 55.1363 40.0586C53.9609 40.8871 52.7321 41.635 51.4499 42.3025C50.2003 42.8051 48.918 42.9653 47.6031 42.7833C43.3014 41.6646 39.0138 40.5025 34.7405 39.2972C34.0834 40.4064 33.1083 40.8338 31.8153 40.5795C31.2995 40.5897 30.7919 40.5496 30.2927 40.4593C29.9721 40.0852 29.9721 39.7113 30.2927 39.3373C31.1664 39.234 32.048 39.1805 32.9373 39.177C33.1836 39.1178 33.3573 38.9709 33.4582 38.7362C33.5117 35.0498 33.5117 31.3633 33.4582 27.6768C33.3647 27.4764 33.2178 27.3295 33.0175 27.236C32.1014 27.2326 31.1932 27.1791 30.2927 27.0757C29.9721 26.7017 29.9721 26.3278 30.2927 25.9538C31.2734 25.8235 32.2618 25.7968 33.2579 25.8736C33.9509 26.0528 34.4451 26.4668 34.7405 27.1158C34.7986 27.1606 34.8654 27.1873 34.9408 27.196C37.2957 26.8092 39.5396 27.1431 41.6727 28.1977C42.4903 28.6678 43.1848 29.2822 43.7563 30.041C45.5194 30.0676 47.2825 30.0944 49.0456 30.1211C50.9407 30.681 51.8356 31.95 51.7303 33.9278C51.5907 34.3613 51.3102 34.6686 50.8889 34.8494C48.2709 34.9029 45.653 34.9029 43.0351 34.8494C42.6329 34.5511 42.5662 34.1905 42.8347 33.7675C42.8948 33.7173 42.9617 33.6773 43.0351 33.6473C45.4926 33.6072 47.9503 33.5938 50.408 33.6072C50.3777 32.5215 49.8435 31.8135 48.8052 31.4835C46.962 31.4568 45.1187 31.43 43.2755 31.4033C43.1356 31.3656 43.002 31.3121 42.8748 31.2431C41.7287 29.614 40.1526 28.7058 38.1465 28.5183C37.0492 28.3638 35.954 28.3772 34.8607 28.5583C34.834 31.6843 34.8607 34.8098 34.9408 37.9348C39.0775 39.0825 43.2181 40.2179 47.3627 41.3408C48.534 41.6144 49.6827 41.5343 50.8087 41.1004C52.9529 39.9754 54.9296 38.613 56.7391 37.0132C59.6975 34.3234 62.3021 31.3448 64.5529 28.0775C64.7427 27.3754 64.4889 26.8812 63.7915 26.5949C63.0981 26.3052 62.4303 26.3586 61.788 26.7552C60.6103 27.9596 59.4082 29.135 58.1817 30.2814C56.7577 31.1839 55.2217 31.8384 53.5736 32.2448C52.9018 32.13 52.6881 31.756 52.9325 31.1229C53.0297 30.9987 53.15 30.9053 53.2931 30.8424C54.4842 30.5255 55.6329 30.0981 56.7391 29.5601C58.2032 28.3101 59.6189 27.0011 60.9866 25.6332C61.5212 25.3261 62.0822 25.1258 62.6696 25.0321Z"
          fill={frameColor}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33.917 13.4982C41.5304 13.4848 49.1438 13.4982 56.7571 13.5382C57.1032 13.6282 57.2635 13.8553 57.2379 14.2194C57.2557 14.4832 57.1487 14.6835 56.9174 14.8205C49.2773 14.8472 41.6372 14.8739 33.9971 14.9006C33.1962 15.0272 32.6486 15.468 32.3542 16.223C32.2656 17.4224 32.2256 18.6245 32.234 19.8293C32.2256 21.0341 32.2656 22.2362 32.3542 23.4356C32.6486 24.1906 33.1962 24.6314 33.9971 24.758C42.6523 24.8114 51.3075 24.8114 59.9627 24.758C61.0368 24.592 61.6111 23.9642 61.6858 22.8747C61.7392 20.8444 61.7392 18.8142 61.6858 16.7839C61.5134 15.5135 60.7788 14.859 59.4819 14.8205C59.1385 14.5217 59.0717 14.1611 59.2815 13.7386C59.4392 13.5968 59.6261 13.5166 59.8425 13.4982C61.3377 13.6038 62.3529 14.3518 62.8879 15.7421C62.9791 17.1005 63.0191 18.4629 63.0081 19.8293C62.9947 21.0849 62.9814 22.3404 62.968 23.5959C62.5629 25.0962 61.5878 25.9377 60.0429 26.1204C51.3342 26.1738 42.6256 26.1738 33.917 26.1204C32.372 25.9377 31.3969 25.0962 30.9918 23.5959C30.9384 21.0849 30.9384 18.5737 30.9918 16.0627C31.4104 14.5616 32.3855 13.7067 33.917 13.4982ZM37.8439 17.1847C38.1396 17.7348 38.4868 18.2557 38.8857 18.7474C39.3923 18.9833 39.9265 19.1169 40.4885 19.1481C40.5824 19.1817 40.6626 19.2351 40.7289 19.3084C40.2533 19.7038 39.866 20.1713 39.5669 20.7108C39.5048 21.266 39.5448 21.8136 39.6871 22.3537C39.6755 22.4156 39.6488 22.4691 39.607 22.514C39.0439 22.3072 38.4695 22.1068 37.8839 21.913C37.257 22.0737 36.6559 22.2875 36.0808 22.5541C36.174 21.9957 36.214 21.4348 36.201 20.8711C36.1429 20.6749 36.0627 20.4878 35.9605 20.3101C35.6228 19.9994 35.3156 19.6654 35.0389 19.3084C35.0714 19.2327 35.1248 19.1792 35.1992 19.1481C35.7211 19.1013 36.2286 18.9944 36.7219 18.8275C36.9222 18.6806 37.0959 18.507 37.2428 18.3066C37.4238 17.9177 37.6241 17.5438 37.8439 17.1847ZM46.8196 17.1847C47.105 17.5135 47.3321 17.8875 47.5008 18.3066C48.0049 18.9118 48.6594 19.1923 49.4643 19.1481C49.5773 19.1776 49.6574 19.2444 49.7047 19.3485C49.2989 19.7407 48.9382 20.1681 48.6228 20.6307C48.483 21.2418 48.523 21.8428 48.743 22.4339C48.6763 22.5006 48.6094 22.5675 48.5427 22.6342C47.4474 21.7794 46.3522 21.7794 45.2569 22.6342C45.1901 22.5675 45.1233 22.5006 45.0565 22.4339C45.3102 21.6799 45.2701 20.9453 44.9363 20.23C44.6692 19.9629 44.402 19.6957 44.1349 19.4286C44.0815 19.3485 44.0815 19.2683 44.1349 19.1882C44.5149 19.0995 44.9023 19.0326 45.297 18.9878C45.7468 18.8851 46.0807 18.6313 46.2987 18.2265C46.4734 17.8771 46.6471 17.5298 46.8196 17.1847ZM55.7954 17.2648C55.8896 17.2472 55.9697 17.274 56.0358 17.3449C56.2395 17.8732 56.5333 18.3407 56.9174 18.7474C57.424 18.9833 57.9582 19.1169 58.5202 19.1481C58.5946 19.1792 58.648 19.2327 58.6805 19.3084C58.4306 19.6386 58.1501 19.9458 57.839 20.23C57.5067 20.9293 57.4666 21.6506 57.7188 22.3938C57.6671 22.4856 57.6003 22.5658 57.5184 22.6342C56.4232 21.7794 55.3279 21.7794 54.2327 22.6342C54.1488 22.5323 54.1088 22.4121 54.1124 22.2736C54.2804 21.7262 54.2938 21.1786 54.1525 20.6307C53.8222 20.1666 53.4615 19.7258 53.0706 19.3084C53.1241 19.2549 53.1774 19.2016 53.2309 19.1481C53.8191 19.1177 54.3801 18.9841 54.9139 18.7474C55.2792 18.2973 55.5731 17.8031 55.7954 17.2648Z"
          fill={frameColor}
        />
      </g>
      <rect
        x="23"
        y="46"
        width="50"
        height="50"
        rx="2"
        fill={frameBackgroundColor}
      />
      <foreignObject
        width="46%"
        height="44px"
        style={{ borderRadius: "3px" }}
        x="26"
        y="49">
        <div
          id="#qrCode"
          style={{
            border: `1px solid ${frameBackgroundColor || "white"}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            backgroundColor: `${frameBackgroundColor}`,
          }}>
          {urlQr ? (
            <img
              src={urlQr}
              width="100%"
              height="auto"
            />
          ) : (
            children
          )}
        </div>
      </foreignObject>
      <foreignObject
        width="100%"
        height="18px"
        y="95">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: "100%", height: "100%", maxWidth: "100%" }}>
          <text
            x="50%"
            y="11"
            fill={textColor}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="sans-serif"
            fontWeight="bold"
            style={{ fontSize }}>
            {text}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
